import {lazy, useMemo} from 'react'

import useMediaQuery from '@mui/material/useMediaQuery'


const HomePage = lazy(() => import('./HomePage'))
const HomePageMobile = lazy(() => import('./mobile/HomePageMobile'))



const HomePageContainer = props => {

  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'))


  const memoizedComponent = useMemo(() => {
    return isLargeScreen ? <HomePage /> : <HomePageMobile />
  }, [isLargeScreen])



  return memoizedComponent
}



export default HomePageContainer



